import { styled, Typography } from "@mui/material";

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 500,
  marginBottom: 10
}));
